module.exports = __webpack_public_path__ + "fef8e6e1b831e557347d1f43a15e9794.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/difficulty_1_a.png
// module id = 155
// module chunks = 0